var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#AAB9C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8982 14.85C12.8982 12.258 15.5082 12.222 15.5082 9.72C15.5082 7.92 14.1582 6.57 11.9082 6.57C9.82024 6.57 8.39824 8.01 8.30824 10.26H10.4682C10.4682 9.18 11.0982 8.55 11.9082 8.55C12.8262 8.55 13.3482 9.09 13.3482 9.9C13.3482 11.52 10.8282 11.52 10.8282 14.85H12.8982ZM10.7382 16.92C10.7382 17.55 11.2782 18.09 11.9082 18.09C12.5382 18.09 13.0782 17.55 13.0782 16.92C13.0782 16.29 12.5382 15.75 11.9082 15.75C11.2782 15.75 10.7382 16.29 10.7382 16.92Z",
    fill: "#FEF4D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipQuestion);
export default __webpack_public_path__ + "static/media/tooltip_question.7be4a4f8.svg";
export { ForwardRef as ReactComponent };